import React from 'react';
import PropTypes from 'prop-types';
import {TextArea} from 'semantic-ui-react';
import {isFunction} from "../../../utils/DBUtils";
import catchUnsavedChanges from 'hoc/catchUnsavedChanges';

// Originally implemented to be stateless,
// but since the value needs to be kept track of to change according to other values (linked values, color picker)
// now keeping track of state. This is duplicate logic of AutoSaveField so might be better to pull up into that
class OnBlurTextArea extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.value !== nextProps.value) {
            this.setState({
                value: nextProps.value
            });
        }
    }

    onBlur = (event, data) => {
        if (isFunction(this.props.onChange)) {
            this.props.onChange(event, {});
            this.props.doneEditing();
        }
    };

    setValue = (event) => {
        this.props.isEditing();
        let value =  event.target.value;
        this.setState({
            value: value
        });

        if (isFunction(this.props.getTextLengthCallback)) {
            this.props.getTextLengthCallback((value || "").length);
        }
    };

    render() {
        const { error, ...newProps } = this.props
        return <TextArea {...newProps}
                         value={this.state.value}
                         onChange={this.setValue}
                         onBlur={this.onBlur}/>;
    }
}

OnBlurTextArea.propTypes = {
    // provided by catchUnsavedChanges HOC
    isEditing: PropTypes.func.isRequired,
    doneEditing: PropTypes.func.isRequired,

    getTextLengthCallback: PropTypes.func
};

export default catchUnsavedChanges(OnBlurTextArea);



// WEBPACK FOOTER //
// ./public/components/forms/BasicFormFields/OnBlurTextArea.jsx